<mat-card appearance="outlined" id="top">
  <mat-card-header>
    <mat-card-title>
      {{ 'LIB_ORDERS.COMMON.LINE_ITEMS.TITLE' | translate }}
    </mat-card-title>
  </mat-card-header>

  <ng-container *ngIf="editing">
    @if ((loading$ | async) === false) {
      <ng-container *ngTemplateOutlet="inventoryPricingTable" />
    } @else {
      <ng-content *ngTemplateOutlet="loadingShimmer"></ng-content>
    }
  </ng-container>

  <ng-template #loadingShimmer>
    <div class="stencil-shimmer"></div>
    <div class="stencil-shimmer total-shimmer"></div>
  </ng-template>
</mat-card>

<ng-template #inventoryPricingTable>
  <ng-container *ngIf="itemPricingTableConfig$ | async as config">
    <inventory-ui-item-pricing-table
      id="inventory-pricing-table"
      [config]="config"
      [selectedItems]="currentLineItems | lineItemsToInventoryItems"
      [viewOnly]="viewOnly"
      [currencyOverride]="currencyOverride"
      [showRetailFrequencySuffix]="true"
      (itemsChanged)="updateLineItemsFromInventoryLineItems($event)"
      (wholesaleSummaryChanged)="onUpdateWholesaleSummary($event)"
    />
  </ng-container>
</ng-template>
